<template>
  <TooltipWrapper v-if="mappedUseCases.length > 0">
    <template #trigger>
      <div class="max-w-[8em] truncate">
        {{ mappedUseCases.join(', ') }}
      </div>
    </template>
    <template #content>
      <div v-for="usecase in mappedUseCases" :key="usecase">
        {{ usecase }}
      </div>
    </template>
  </TooltipWrapper>
  <div v-else>---</div>
</template>
<script setup lang="ts">
import { TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'

import type { SurveyRespsonseReviewPurposes } from './types'

const props = defineProps<{
  useCases?: SurveyRespsonseReviewPurposes[]
}>()

const mappedUseCases = computed(() => {
  if (props.useCases) {
    return props.useCases.map((useCase) => useCase.title)
  }
  return []
})
</script>
